import React from 'react';

/** The approved pill tab switcher (Deep Green active pill on sand track). */
export function SegmentedTabs<T extends string>({
  tabs,
  value,
  onChange,
  label
}: {
  tabs: {
    id: T;
    label: string;
  }[];
  value: T;
  onChange: (id: T) => void;
  label: string;
}) {
  return <div className="flex gap-1 rounded-pill bg-sand-deep/70 p-[3px]" role="tablist" aria-label={label} data-id="element-1405" data-mp="3hmx9k53h31x0">
      {tabs.map(tab => <button key={tab.id} type="button" role="tab" aria-selected={value === tab.id} onClick={() => onChange(tab.id)} className={`min-h-[36px] flex-1 whitespace-nowrap rounded-pill px-1 text-[12px] font-medium transition-colors duration-150 ease-brand ${value === tab.id ? 'bg-deep text-sand' : 'text-muted hover:text-deep'}`} data-id="element-1406" data-mp="3cpdskxfe4b1d">
          {tab.label}
        </button>)}
    </div>;
}